import React, { Component } from 'react';
import { Card, Divider, Timeline } from 'antd';
import moment from 'moment-timezone';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class Status extends Component {
    render() {
        const timezone = this.props.store.userStore.currentUser.timezone;

        return (
            <Card title="Status" bordered={false}>
                <b>Cooldown Expires:</b> {this.renderCooldown()}
                <br />
                <b>Last Rule Fired: </b> {this.renderLastFired()}
                <br />
                <Divider orientation={'left'}>Logs</Divider>
                <Timeline>
                    {this.props.store.botStore.triggerStore.logs.map((log, i) => {
                        return (
                            <Timeline.Item color={log.type === 'error' ? 'red' : 'blue'} key={i}>
                                {log.message}{' '}
                                {moment(log.date)
                                    .tz(timezone)
                                    .format('MMMM Do YYYY, h:mm:ss a')}
                            </Timeline.Item>
                        );
                    })}
                </Timeline>
            </Card>
        );
    }

    renderCooldown() {
        const cd = this.props.store.botStore.triggerStore.status.cooldown || 0;

        if (cd > 0) {
            return (cd / 1000).toFixed(0) + ' seconds';
        }
        return 'Expired';
    }

    renderLastFired() {
        const lastFired = this.props.store.botStore.triggerStore.status.last_trigger;

        if (lastFired === undefined || null == lastFired) return 'None';
        if (lastFired === 'default') return 'Default State';
        const trigger = this.props.store.botStore.currentConfiguration.triggers[lastFired];
        return trigger ? trigger.name : 'Deleted Trigger';
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/TriggerView/Status.js